'use client'

import { useContext, useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import {
    useMediaQuery,
    Avatar,
    ClickAwayListener,
    Grid,
    List,
    ListItemButton,
    ListItemIcon,
    ListSubheader,
    ListItemText,
    Paper,
    Popper,
    Typography,
    Tooltip,
    IconButton
} from '@mui/material';

// project imports
import Banner from './Banner';
import MainCard from '@/app/ui-component/cards/MainCard';
import Transitions from '@/app/ui-component/extended/Transitions';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// import { IconAccessPoint, IconAntenna } from '@tabler/icons';
import { drawerWidth, gridSpacing } from '@/app/store/constant';
import { useIntl } from "react-intl";
import { useSelector } from '@/app/store';
import { IconAntenna } from '@tabler/icons-react';

import { Shortcut } from '@mui/icons-material';


const HeaderAvatarStyle = styled(Avatar)(({ theme }) => ({
    ...theme.typography.commonAvatar,
    ...theme.typography.mediumAvatar,
    background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
    color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
    '&:hover': {
        background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
        color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
    }
}));

// ==============================|| SEARCH INPUT - MEGA MENu||============================== //

const MegaMenuSectionInscription = () => {

    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const intl = useIntl();
    const navigate = useRouter();
    const { paramMemoire } = useSelector((state) => state.diversParametersRedux);
    const [alterarSenha, setAlterarSenha] = useState("");

    const [typeUtilisateur, settypeUtilisateur] = useState("");

  const textColor = theme.palette.mode === 'dark' ? 'white' : "red";
  const [universityOuCollege, setUniversityOuCollege] = useState(1);

  
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    useEffect(() => {
        
          paramMemoire.map((item) => {
            setAlterarSenha(item.alterarSenha);
            settypeUtilisateur(item.typeUtilisateur);
            setUniversityOuCollege(item.universityOuCollege);

        });

        if (matchDownMd && open) setOpen(false);
        // eslint-disable-next-line
    }, [matchDownMd, alterarSenha, typeUtilisateur]);

    return (
        <>
        {Number(alterarSenha) === 1 ?  (
        <>
            <HeaderAvatarStyle
                variant="rounded"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                sx={{ display: { xs: 'none', md: 'flex' } }}
            >
                 <Tooltip arrow placement="top" title= {intl.formatMessage({ id: "atalho_preinscription" })}>
                <Shortcut color="primary">
                <IconAntenna stroke={1.5} size="1.3rem" />
                </Shortcut>
              </Tooltip>


            </HeaderAvatarStyle>
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [150, 20]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={handleClose}>
                        <Transitions in={open} {...TransitionProps}>
                            <Paper
                                sx={{
                                    width: {
                                        md: `calc(100vw - 100px)`,
                                        lg: `calc(100vw - ${drawerWidth + 100}px)`,
                                        xl: `calc(100vw - ${drawerWidth + 140}px)`
                                    },
                                    maxWidth: { xl: 900, md: 764 }
                                }}
                            >
                                {open && (
                                    <MainCard 
                                    title={
                                        <Grid container alignItems="center" justifyContent="space-between" spacing={3}>
                                            <Grid item>
                                                <Typography variant="h3">{intl.formatMessage({ id: "atalho" })}</Typography>
                                            </Grid>
                                            </Grid>
                                    }
                                        border={false}
                                        elevation={16}
                                        content={false}
                                        boxShadow
                                        shadow={theme.shadows[16]}
                                        sx={{ p: 1, overflow: { xs: 'visible', md: 'hidden' } }}
                                    >
                                        <Grid container spacing={gridSpacing}>
                                            
                                        {Number(typeUtilisateur) === 1?
                                            <Grid item md={12}>
                                                <Grid
                                                    container
                                                    spacing={gridSpacing}
                                                    sx={{
                                                        pt: 3,
                                                        '& .MuiListItemButton-root:hover': {
                                                            background: 'transparent',
                                                            '& .MuiTypography-root': {
                                                                color: 'secondary.main'
                                                            }
                                                        },
                                                        '& .MuiListItemIcon-root': {
                                                            minWidth: 16
                                                        }
                                                    }}
                                                >
                                                    <Grid item xs={3}>
                                                        <List
                                                            component="nav"
                                                            aria-labelledby="nested-list-user"
                                                            subheader={
                                                                <ListSubheader id="nested-list-user">
                                                                  
                                                                    <Typography style={{color:textColor, fontWeight:600, textDecoration: "underline"}} 
                                                                    variant="subtitle1">1. {intl.formatMessage({ id: "gestion_cours_megaMenu" })}
                                                                    </Typography>
                                                                
                                                                </ListSubheader>
                                                            }
                                                        >
                                                    
                                                     {Number(universityOuCollege) < 3 ?
                                                           <Link href="/cours/enregistrercours" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "enregistrer_cours" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                        :null}

                                                        {Number(universityOuCollege) === 3 ?
                                                           <Link href="/cours/enregistrercoursSchools" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "enregistrer_cours" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                        :null}
                                                   
                                                     {Number(universityOuCollege) < 3 ?
                                                        <Link href="/cours/coursList" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "liste_cours" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                        :null}

                                                        {Number(universityOuCollege) === 3 ?
                                                        <Link href="/cours/coursListSchools" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "liste_cours" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                        :null}
                                                        

                                                        <Link href="/grillesFiche/DeliberationPremiereSession" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "deliberation_premiere_session" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="/grillesFiche/FicheCotationSession1" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "ficheCotationSession1" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="/notas/ControleEnrefistremenrtPoints" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "controle_enregistrement_point1" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                            
                                            </List>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <List
                                                            component="nav"
                                                            aria-labelledby="nested-list-application"
                                                            subheader={
                                                                <ListSubheader id="nested-list-application">
                                                                    <Typography style={{color:textColor, fontWeight:600, textDecoration: "underline"}} variant="subtitle1">2. {intl.formatMessage({ id: "gestion_estudantes_megaMenu" })}</Typography>
                                                                </ListSubheader>
                                                            }
                                                        >

                                                        {Number(universityOuCollege) < 3 ?
                                                        <Link href= "/etudiants/NewStudents" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "mouveauEtudiant" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                        :null }

                                                    {Number(universityOuCollege)  ===3 ?
                                                        <Link href= "/etudiants/NewStudentsSchools" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "mouveauEtudiant" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                        :null }
                            
                                                        <Link href="/etudiants/ListEtudiants" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "listEtudiants" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        

                                                        {Number(universityOuCollege)  <3 ?
                                                        <Link href="/etudiants/ReleveCoteImpression" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "bulletin_de_points" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                        :null}

                                                        {Number(universityOuCollege)  ===3 ?
                                                        <Link href="/etudiants/ReleveCoteImpressionSchools" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "bulletin_de_points" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                        :null}

                                                        <Link href="/etudiants/ExtraitCommpteEtudiant" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "extrait_compite_etudia" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="/paiements/PaiementDesFrais" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "paiement_des_frais" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                       
                                                        </List>
                                                    </Grid>

                                                    <Grid item xs={3}>
                                                        <List
                                                            component="nav"
                                                            aria-labelledby="nested-list-primitives"
                                                            subheader={
                                                                <ListSubheader component="div" id="nested-list-primitives">
                                                                    <Typography style={{color:textColor, fontWeight:600 , textDecoration: "underline"}} variant="subtitle1">3. {intl.formatMessage({ id: "professeurs_" })}</Typography>
                                                                </ListSubheader>
                                                            }
                                                        >

                                                            <Link href="/professor/NewProf" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "enregistrerProfesseur" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="/professor/AfectacaoCours" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "afectercour_a_professeur" })} />
                                                            </ListItemButton>
                                                        </Link>    

                                                        <Link href="/professor/HorarioDoProfesseor" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "horarios_em_grafico" })} />
                                                            </ListItemButton>
                                                        </Link>    

                                                        <Link href="/professor/ListeGeneralProfesseurs" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "listProf" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="/professor/CategoriasTravailleurs" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "categorias_travalleurs" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                           
                                                        </List>
                                                    </Grid>

                                                    <Grid item xs={3}>
                                                        <List
                                                            component="nav"
                                                            aria-labelledby="nested-list-primitives"
                                                            subheader={
                                                                <ListSubheader component="div" id="nested-list-primitives">
                                                                    <Typography style={{color:textColor, fontWeight:600, textDecoration: "underline"}} 
                                                                    variant="subtitle1">4. {intl.formatMessage({ id: "gestion_des_paiements" })}</Typography>
                                                                </ListSubheader>
                                                            }
                                                        >

                                                            <Link href="/paiements/PaiementDesFrais" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "paiement_des_frais" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href='/paiements/ListeEtudiantsEnOrdrePaiements' passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "etudiant__en__ordre__paiement" })} />
                                                            </ListItemButton>
                                                        </Link>    

                                                        <Link href="/paiements/ListeEtudiantsEnOrdrePasPaiements" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "etudiant__non__en__ordre__paiement" })} />
                                                            </ListItemButton>
                                                        </Link>    

                                                        <Link href="/caisse/CaisseDuJour" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "mouvements_du_jour" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="/caisse/CaisseOperateur" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "mouvement_por_operador" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                           
                                                        </List>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        :null}

                                    {/* ####################  PROFESSEURS  #########################*/}
                                    {Number(typeUtilisateur) ===2?
                                            <Grid item md={12}>
                                                <Grid
                                                    container
                                                    spacing={gridSpacing}
                                                    sx={{
                                                        pt: 3,
                                                        '& .MuiListItemButton-root:hover': {
                                                            background: 'transparent',
                                                            '& .MuiTypography-root': {
                                                                color: 'secondary.main'
                                                            }
                                                        },
                                                        '& .MuiListItemIcon-root': {
                                                            minWidth: 16
                                                        }
                                                    }}
                                                >
                                                    <Grid item xs={4}>
                                                        <List
                                                            component="nav"
                                                            aria-labelledby="nested-list-user"
                                                            subheader={
                                                                <ListSubheader id="nested-list-user">

                                                                <Typography style={{color:textColor, fontWeight:600, textDecoration: "underline"}} 
                                                                    variant="subtitle1">1. {intl.formatMessage({ id: "diversos_atalhos" })}
                                                                    </Typography>

                                                                </ListSubheader>
                                                            }
                                                        >
                                                           <Link href="/professor/HorarioDoProfesseor" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "horarios_em_grafico" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="/notas/LancerPointInterrogrationAntesExameApi" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "LancerPointInterrogrationAntesExame" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="/notas/LancerPointInterrogrationTPProfAPi" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "Lancamento_nnotas_exame" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="/notas/LancerPointSession2ProfApi" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "lancerpoint_deuxiemeSession" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                            
                                            </List>
                                                    </Grid>
                                                    

                                                </Grid>
                                            </Grid>
                                        :null}
                                    {/* ##############FIM PROFESSEURS ######################## */}

                                            {Number(typeUtilisateur) ===3?
                                            <Grid item md={12}>
                                                <Grid
                                                    container
                                                    spacing={gridSpacing}
                                                    sx={{
                                                        pt: 3,
                                                        '& .MuiListItemButton-root:hover': {
                                                            background: 'transparent',
                                                            '& .MuiTypography-root': {
                                                                color: 'secondary.main'
                                                            }
                                                        },
                                                        '& .MuiListItemIcon-root': {
                                                            minWidth: 16
                                                        }
                                                    }}
                                                >
                                                    <Grid item xs={4}>
                                                        <List
                                                            component="nav"
                                                            aria-labelledby="nested-list-user"
                                                            subheader={
                                                                <ListSubheader id="nested-list-user">
                                                                     <Typography style={{color:textColor, fontWeight:600, textDecoration: "underline"}} 
                                                                    variant="subtitle1">1. {intl.formatMessage({ id: "informacao_estudante" })}
                                                                    </Typography>

                                                                </ListSubheader>
                                                            }
                                                        >
                                                           <Link href="/portailEtudiant/Matriculas" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "donnees_et_inscription" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="#" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "agrega_familial" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href="#" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "documentos_digitais" })} />
                                                            </ListItemButton>
                                                        </Link>
                                                            
                                            </List>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <List
                                                            component="nav"
                                                            aria-labelledby="nested-list-application"
                                                            subheader={
                                                                <ListSubheader id="nested-list-application">
                                                                      <Typography style={{color:textColor, fontWeight:600, textDecoration: "underline"}} 
                                                                    variant="subtitle1">1. {intl.formatMessage({ id: "financas_module" })}
                                                                    </Typography>
                                                                </ListSubheader>
                                                            }
                                                        >
                                                        <Link href= "/portailEtudiant/SaldoEstudanteStudent" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "solde_financier" })} />
                                                            </ListItemButton>
                                                        </Link>
                            
                                                        <Link href="/portailEtudiant/PaiementDesFraisEtudiant" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "pagamentos_emolumentos" })} />
                                                            </ListItemButton>
                                                        </Link>



                                                        <Link href="/portailEtudiant/ExtraitCommpteEtudiantApi" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "extrait_compite_etudia" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                                                               
                                                        </List>
                                                    </Grid>

                                                    <Grid item xs={4}>
                                                        <List
                                                            component="nav"
                                                            aria-labelledby="nested-list-primitives"
                                                            subheader={
                                                                <ListSubheader component="div" id="nested-list-primitives">

                                                                    <Typography style={{color:textColor, fontWeight:600, textDecoration: "underline"}} 
                                                                    variant="subtitle1">1. {intl.formatMessage({ id: "diversos_atalhos" })}
                                                                    </Typography>
                                                                </ListSubheader>
                                                            }
                                                        >

                                                            <Link href="/portailEtudiant/ReleveCoteImpressionEtudiantApi" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "bulletin_de_points" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                            <Link href="/portailEtudiant/HorarioDoEstudanteStudents" passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "horarioDoEstudante" })} />
                                                            </ListItemButton>
                                                        </Link>

                                                        <Link href='/portailEtudiant/ClasseVirtuelle'passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "salle_virtuelle" })} />
                                                            </ListItemButton>
                                                        </Link>    

                                                        <Link href='/portailEtudiant/DeclarationsEDiplome' passHref>
                                                            <ListItemButton disableRipple onClick={handleClose}>
                                                                <ListItemIcon>
                                                                    <FiberManualRecordIcon sx={{ fontSize: '0.5rem' }} />
                                                                </ListItemIcon>
                                                                <ListItemText primary={intl.formatMessage({ id: "declaracoes_et_diplomes" })} />
                                                            </ListItemButton>
                                                        </Link>    

                                                           
                                                        </List>
                                                    </Grid>

                                                    
                                                </Grid>
                                            </Grid>
                                        :null}
                                        </Grid>
                                    </MainCard>
                                )}
                            </Paper>
                        </Transitions>
                    </ClickAwayListener>
                )}
            </Popper>
            </>
            ):null
           
        }
        </>
    );
};

export default MegaMenuSectionInscription;
